namespace RedBullMOBILE360.CustomerCare {
    export class UnBlockedSMSCustomersColumns {
        static columnsKey = 'CustomerCare.UnBlockedSMSCustomers';
    }
}
